import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import Button from '../../../../global/atoms/button';
import GlobalModal from '../../../../global/atoms/globalModal/GlobalModal';
import { getJoinAccountData } from '../../utils/cashflowUtils';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../../constants/analyticsConstants/Ecommerce';
import TimeoutIcon from '../../../../../resources/images/time_out.svg';
import { VerificationTimeOutTestId } from '../../../GRTestId';
import './JoinCashVerificationTimeoutModal.scss';

const JoinCashVerificationTimoutModal = ({ timeoutModal, hideTimeoutModal, resendCode }) => {
    const { screenConfig = {} } = getJoinAccountData() || {};
    const { timeoutWarningTitle = '', timeoutWarningDescription = '', ctaLabelTimeout = '' } = screenConfig || {};
    const { sendEventsForGRModalOpened, sendEventsForGRModalCompleted } = useAnalyticsContext();

    const handleResendCode = () => {
        hideTimeoutModal();
        resendCode();
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_TIMEOUT,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            ctaLabelTimeout
        );
    };

    useEffect(() => {
        if (timeoutModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_TIMEOUT,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        }
    }, []);

    const getTitle = () => {
        return (
            <>
                <TimeoutIcon tabIndex={'-1'} aria-hidden={true} />
                <span>{timeoutWarningTitle}</span>
            </>
        );
    };

    const getContent = () => {
        return (
            <>
                <span data-testid={VerificationTimeOutTestId.MODAL_DESCRIPTION}>{timeoutWarningDescription}</span>
                <div className="helpmodal__actions">
                    {ctaLabelTimeout && (
                        <Button
                            data-testid={VerificationTimeOutTestId.RESEND_BUTTON}
                            tabIndex={0}
                            buttonAriaLabel={ctaLabelTimeout}
                            className={`button button-primary button-block`}
                            onClick={handleResendCode}>
                            {ctaLabelTimeout}
                        </Button>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <GlobalModal
                titleClasses={'timeout-modal_title'}
                className={'width-327'}
                isOpen={timeoutModal}
                onRequestClose={hideTimeoutModal}
                title={getTitle()}
                content={getContent()}
                handleClose={hideTimeoutModal}
            />
        </>
    );
};

export default memo(JoinCashVerificationTimoutModal);

JoinCashVerificationTimoutModal.propTypes = {
    timeoutModal: propTypes.bool,
    hideTimeoutModal: propTypes.func
};
